import { useFetchAllCourierWorkShifts } from '@@partner:graphql/query/courier/allCourierWorkShifts.gql'
import { GQL_ID } from '@@partner:types:graphql'
import AppLoader from '@components/common/AppLoader'
import React from 'react'
import { Panel } from 'rsuite'
import { VehicleShiftElement } from './VehicleShiftsList'


type VehicleShiftsListProps = {
  vehicleId: GQL_ID
}

export default function LastActiveVehicleShift ({
  vehicleId
}: VehicleShiftsListProps) {
  const { courierWorkshifts, loading, error } = useFetchAllCourierWorkShifts({
    filter: {
      and: [
        {
          fields: [ 'vehicle_id' ],
          op: 'eq',
          value: vehicleId
        },
        {
          fields: [ 'status' ],
          op: 'eq',
          value: 1
        }
      ]
    },
    pager: {
      limit: 1
    }
  })

  if (loading) {
    return <AppLoader.RowsWithText 
      rows={3}
      columns={1}
      rowHeight={24}
      rowMargin={12}
      content="Загружаем смены"
    />
  }
  if (error) {
    return (
      <Panel bordered header="Ошибка загрузки" className="text-center">
        <p className="text-danger">Не удалось загрузить список смен</p>
      </Panel>
    )
  }

  if (courierWorkshifts.length === 0) {
    return (
      <Panel bordered header="Нет активных смен" className="text-center">
        <p className="text-muted">Для данного транспорта нет активных смен</p>
      </Panel>
    )
  }

  return (
    <div className='VehicleShiftsList'>
      { courierWorkshifts.map(cwf => (
        <VehicleShiftElement
          key={cwf.id}
          shift={cwf}
          className='VehicleShiftsList__Element'
        />
      ))}
    </div>
  )
}